<template>
    <div class="waiting-list__form">
        <p class="waiting-list__form-field-title">{{ dictionary.WaitingListFormDepartmentRoomTitle }}</p>
        <div class="form-grid grid">
            <div class="field col-12 sm:col-6">
                <label for="department">Lokation</label>
                <Dropdown id="department" v-model="v$.model.DepartmentId.$model"
                    :placeholder="dictionary.WaitingListFormDepartmentFieldPlaceholder" :options="departments"
                    optionLabel="Name" optionValue="Id" filter :class="{ 'p-invalid': v$.model.DepartmentId.$invalid }" />
            </div>
            <div class="field col-12 sm:col-6">
                <label for="roomSize">Rumstørrelse</label>
                <Dropdown id="roomSize" v-model="v$.model.RoomSize.$model"
                    :placeholder="dictionary.WaitingListFormRoomSizeFieldPlaceholder" :options="rooms"
                    :class="{ 'p-invalid': v$.model.RoomSize.$invalid }" :disabled="v$.model.DepartmentId.$invalid">
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            {{ slotProps.value.toFixed(1) }} m2
                        </div>
                        <div v-else-if="v$.model.DepartmentId.$invalid">
                            Vælg først afdeling
                        </div>
                        <div v-else>
                            {{ slotProps.placeholder }}
                        </div>
                    </template>
                    <template #option="slotProps">
                        {{ slotProps.option.toFixed(1) }} m2
                    </template>
                </Dropdown>
            </div>
        </div>
        <p class="waiting-list__form-field-title">{{ dictionary.WaitingListFormPersonalDetailsTitle }}</p>
        <div class="form-grid grid">
            <div class="field col-12 sm:col-6">
                <label for="firstName">Fornavn</label>
                <InputText id="firstName" type="text" v-model="v$.model.FirstName.$model"
                    :class="{ 'p-invalid': v$.model.FirstName.$invalid }" />
            </div>
            <div class="field col-12 sm:col-6">
                <label for="lastName">Efternavn</label>
                <InputText id="lastName" type="text" v-model="model.LastName" />
            </div>
            <div class="field col-12 sm:col-6">
                <label for="phone">Telefonnummer</label>
                <InputText id="phone" type="text" v-model="v$.model.Phone.$model"
                    :class="{ 'p-invalid': v$.model.Phone.$invalid }" />
            </div>
        </div>
        <div class="form-grid grid">
            <div class="field col">
                <div class="field-checkbox">
                    <Checkbox inputId="roomSizeDisclaimer" v-model="v$.model.AcceptsRoomSizeDisclaimer.$model"
                        :binary="true" :class="{ 'p-invalid': v$.model.AcceptsRoomSizeDisclaimer.$invalid }" />
                    <label class="waiting-list__form-legal" for="roomSizeDisclaimer">{{
                        dictionary.WaitingListFormRoomDisclaimer }}</label>
                </div>
            </div>
        </div>
        <div class="form-grid grid">
            <div class="field col">
                <div class="field-checkbox">
                    <Checkbox inputId="gdprDisclaimer" v-model="v$.model.AcceptsGDPRDisclaimer.$model" :binary="true"
                        :class="{ 'p-invalid': v$.model.AcceptsGDPRDisclaimer.$invalid }" />
                    <label class="waiting-list__form-legal" for="gdprDisclaimer" v-html="dictionary.FormsGDPRText"></label>
                </div>
            </div>
        </div>
        <Button class="p-button-primary p-button-rounded" @click="handleWaitListSubmission">{{
            dictionary.WaitingListFormSubmitButtonText }}</Button>
        <Toast />
    </div>
</template>
<script>


import { useVuelidate } from '@vuelidate/core'
import { required, integer, minLength, maxLength, sameAs } from '@vuelidate/validators'
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import Checkbox from 'primevue/checkbox';
import VueHelpers from './vueHelpers';

const serviceUrl = "/umbraco/api/departmentsapi/";

export default {
    name: "waitingList",
    components: {
        InputText,
        Dropdown,
        Button,
        Toast,
        Checkbox
    },
    data() {
        return {
            dictionary: [],
            departments: [],
            rooms: [],
            searchValue: null,
            isLoading: false,
            model: {
                DepartmentId: null,
                RoomSize: null,
                FirstName: null,
                LastName: null,
                Phone: null,
            },
            presetDepartment: null,
            presetSize: null
        };
    },
    setup() {
        return { v$: useVuelidate() }
    },
    created() {
        const vm = this;

        const urlParams = new URLSearchParams(window.location.search);
        const departmentId = urlParams.get('departmentId');
        const size = urlParams.get('size');
        if (departmentId) {
            vm.presetDepartment = departmentId;
        }
        if (size) {
            vm.presetSize = parseFloat(size.replace(',', '.'));
        }

        fetch("/umbraco/api/dictionaryapi/GetWaitingListDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

        fetch(serviceUrl + "GetAllDepartmentsSimple").then(response => response.json())
            .then(data => {
                vm.departments = data;
                if (vm.presetDepartment && vm.departments.some(x => x.Id == vm.presetDepartment)) {
                    vm.model.DepartmentId = vm.presetDepartment;
                }
            })
            .catch(error => {
                console.log(error)
            })
    },
    validations() {
        return {
            model: {
                DepartmentId: { required },
                RoomSize: { required },
                FirstName: { required },
                Phone: {
                    required,
                    integer,
                    minLengthValue: minLength(8),
                    maxLengthValue: maxLength(8)
                },
                AcceptsRoomSizeDisclaimer: {
                    sameAs: sameAs(true),
                },
                AcceptsGDPRDisclaimer: {
                    sameAs: sameAs(true),
                }

            }
        }
    },
    watch: {
        'model.DepartmentId': function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.getRooms();
            }
        },
        'v$.model.DepartmentId.$model': function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.model.RoomSize = null;
            }
        }
    },
    methods: {
        getRooms() {
            const vm = this;
            vm.toggleSpinner(true);

            fetch(serviceUrl + "GetRoomSizesByDepartment?departmentId=" + vm.model.DepartmentId + "&distinct=true&availability=false").then(response => {
                if (response.status == 404) {
                    const error = new Error('No department found');
                    error.name = response.status;
                    throw error;
                } else {
                    return response.json();
                }
            })
                .then(data => {
                    vm.rooms = data;
                    if (vm.presetSize && vm.rooms.some(x => x == vm.presetSize)) {
                        vm.model.RoomSize = vm.presetSize;
                    }
                    vm.toggleSpinner(false);
                })
                .catch(error => {
                    console.log(error.name);
                    if(error.name == "404") {
                    vm.rooms = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
                    }
                    vm.toggleSpinner(false);
                    console.log(error)
                })
        },
        handleWaitListSubmission() {
            const vm = this;
            if (!vm.v$.$invalid) {
                vm.toggleSpinner(true);

                fetch('/umbraco/api/bookingApi/postRequestBookingForm', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify(vm.model),
                })
                    .then(data => {
                        vm.toggleSpinner(false);
                        if (data.status == 200) {

                            vm.editMode = false;
                            vm.$toast.add({ severity: 'success', summary: vm.dictionary.WaitingListFormSubmissionSuccessTitle, detail: vm.dictionary.WaitingListFormSubmissionSuccessText, life: 10000 });
                        } else {
                            vm.$toast.add({ severity: 'error', summary: vm.dictionary.WaitingListFormGeneralErrorTitle, detail: vm.dictionary.WaitingListFormGeneralErrorText, life: 10000 });
                        }
                    }).catch(error => {
                        vm.toggleSpinner(false);

                        console.log(error);
                    })
            } else {
                vm.$toast.add({
                    severity: 'error', closable: false, summary: vm.dictionary.WaitingListFormMissingInformationErrorTitle, detail: vm.dictionary.WaitingListFormMissingInformationErrorText, life: 10000
                })
            }
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    }
};
</script>
